/* import __COLOCATED_TEMPLATE__ from './select-attribute.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type { HitlAttributeDefinition } from 'embercom/objects/inbox/conversation';
import type IntlService from 'embercom/services/intl';
import type InboxHotkeys from 'embercom/services/inbox-hotkeys';

interface Signature {
  Args: {
    attribute: HitlAttributeDefinition;
    value: string;
    onSelect: (value: string) => void;
  };
}

export default class SelectAttribute extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare inboxHotkeys: InboxHotkeys;

  get items(): Array<{ text: string; value: string }> {
    if (this.args.attribute.options?.length) {
      return this.args.attribute.options.map((option) => ({
        text: option,
        value: option,
      }));
    }
    if (this.args.attribute.type === 'boolean') {
      return [
        { text: this.intl.t('inbox.composer.hitl-card.boolean-true'), value: 'true' },
        { text: this.intl.t('inbox.composer.hitl-card.boolean-false'), value: 'false' },
      ];
    }
    return [];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Composer::HitlCard::SelectAttribute': typeof SelectAttribute;
    'inbox2/composer/hitl-card/select-attribute': typeof SelectAttribute;
  }
}
